import React, { useEffect, useState } from 'react';
import WelcomeUser from '../welcome-user/welcome-user';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import { Storage } from 'react-jhipster';
import { useAppDispatch } from 'app/config/store';
import { fetchDistanceLimit } from 'app/shared/reducers/distance-limit';
import InputAdornment from '@mui/material/InputAdornment';
import EventsSlider from './event-slider';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Switch from '@mui/material/Switch';



const EventsNearYou = () => {
  const [textFieldDistance, setTextFieldDistance] = useState<number>(0);
  const [sliderDistance, setSliderDistance] = useState<number | string>(100);
  const [defaultMaxDistance, setDefaultMaxDistance] = useState<number>(100);
  const [sliderDisabled, setSliderDisabled] = useState<boolean>(false);
  const [distanceUnit, setDistanceUnit] = useState<any>('km');
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  let maxLimitFromStorage: number;
  let defaultDistance: number;

  useEffect(() => {
    if (Storage.session.get('Maxdistance')) {
      const maxDistanceFromStorage = Storage.session.get('Maxdistance');
      const defaultDistanceFromStorage = Storage.session.get('defaultDistance');
      if (maxDistanceFromStorage) {
        maxLimitFromStorage = JSON.parse(maxDistanceFromStorage);
      }
      if (defaultDistanceFromStorage) {
        defaultDistance = JSON.parse(defaultDistanceFromStorage);
      }
      setDefaultMaxDistance(defaultDistance);
      if (Storage.session.get('ActiveField') == 'TextField') {
        setTextFieldDistance(maxLimitFromStorage);
      } else {
        setSliderDistance(maxLimitFromStorage);
      }

      if (Storage.session.get('DistanceUnit')) {
        setDistanceUnit(Storage.session.get('DistanceUnit'));
      }
    } else {
      const fetchData = async () => {
        try {
          const response = await dispatch(fetchDistanceLimit());
          setDefaultMaxDistance(Number(response.payload));
        } catch (error) {
          console.log(error);
        }
      };
      fetchData();
    }
  }, []);
  const input = document.querySelector('input[name="locationRange"]');

  if (input) {
    input.addEventListener('wheel', function (event) {
      event.preventDefault();
    });
  }

  const handleTextFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseFloat(event.target.value);
    setTextFieldDistance(value);
  };
  useEffect(() => {
    if (textFieldDistance > 0) {
      setSliderDisabled(true);
      setSliderDistance(0);
    } else {
      setSliderDisabled(false);
    }
  }, [textFieldDistance]);
  const handleSliderChange = (newValue: number) => {
    console.log('New slider value:', newValue);
  };

  return (
    <Grid container direction="column" justifyContent="flex-start" alignItems="center" minHeight="100vh" py={5}>
      <WelcomeUser />
      <Stack direction="column" spacing={5} alignItems="center" marginBottom={'16px'} sx={{ px: { xs: 2, md: 0 } }}>
        <Typography sx={{ fontSize: '24px', color: 'secondary.light', fontWeight: 600 }}>Want to know about events near you?</Typography>

        <div className="col-12">
          <div className="col-12 d-flex justify-content-between">
            {' '}
            <p style={{ fontSize: '12px', color: 'secondary.light', marginBottom: '0' }}>0 {distanceUnit}</p>
            <p style={{ fontSize: '12px', color: 'secondary.light', marginBottom: '0' }} className="ms-4">
              100 {distanceUnit}(approx.)
            </p>
          </div>
          <div className="col-12 w-100 ps-2 pe-2">
            <EventsSlider
              sliderDistance={sliderDistance}
              sliderDisabled={sliderDisabled}
              setSliderDistance={setSliderDistance}
              defaultMaxDistance={defaultMaxDistance}
              onSliderChange={handleSliderChange}
            />
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '5px' }}>
          <p style={{ fontSize: '14px', color: 'secondary.light' }}> {sliderDistance != '0' ? sliderDistance : ''} </p>
          <Stack direction="row" alignItems="center" >
            <Typography variant="body2" sx={{ fontSize: '12px', color: 'secondary.light' }}>km</Typography>
            <Switch
              checked={distanceUnit === 'miles'}
              onChange={(event) => {
                setDistanceUnit(event.target.checked ? 'miles' : 'km');
              }}
              inputProps={{ 'aria-label': 'Distance unit switch' }}
              size="small"
              sx={{
                '& .MuiSwitch-switchBase': {
                  color: '#674BFF !important',
                },
                '& .MuiSwitch-switchBase.Mui-checked': {
                  color: '#674BFF !important',
                },
                '& .MuiSwitch-track': {
                  backgroundColor: '#674BFF !important',
                },
                '& .MuiSwitch-track.Mui-checked': {
                  backgroundColor: '#674BFF !important',
                },
                '& .Mui-checked+.MuiSwitch-track': {
                  backgroundColor: '#674BFF !important',
                },
              }}
            />
            <Typography variant="body2" sx={{ fontSize: '12px', color: 'secondary.light' }}>miles</Typography>
          </Stack>

          {/* <ToggleButtonGroup
          value={distanceUnit}
          exclusive
          onChange={(event, newUnit) => {
            if (newUnit) setDistanceUnit(newUnit);
          }}
          aria-label="distance unit"
          size="small"
          sx={{
            height: '24px',
            '& .MuiToggleButton-root': {
              fontSize: '10px',
              padding: '2px 6px',
              minWidth: 'unset',
            },
          }}
        >
          <ToggleButton value="km" aria-label="kilometers">km</ToggleButton>
          <ToggleButton value="miles" aria-label="miles">miles</ToggleButton>
        </ToggleButtonGroup> */}

        </div>
        {/* <TextField
          type="number"
          InputProps={{ inputProps: { min: 0, max: 10000 }, endAdornment: <InputAdornment position="end">km</InputAdornment> }}
          name="locationRange"
          fullWidth
          size="small"
          value={textFieldDistance}
          onChange={handleTextFieldChange}
        /> */}
        <Grid item container alignItems="center" justifyContent={'space-between'} my={3}>
          <Button
            onClick={() => {
              if (sliderDisabled) {
                Storage.session.set('Maxdistance', textFieldDistance);
                Storage.session.set('ActiveField', 'TextField');
                Storage.session.set('DistanceUnit', distanceUnit);
              } else {
                Storage.session.set('Maxdistance', sliderDistance);
                Storage.session.set('ActiveField', 'Slider');
                Storage.session.set('DistanceUnit', distanceUnit);
              }
              navigate('/welcome');
            }}
            variant="outlined"
            sx={{
              textTransform: 'none',
              width: '89px',
              height: '40px',
              borderRadius: '15px',
              border: '1px solid #FFCE00',
              boxShadow: 'none',
              '&:hover': { boxShadow: 'none' },
            }}
          >
            <Typography>Back</Typography>
          </Button>
          <Button
            onClick={() => {
              if (sliderDisabled) {
                Storage.session.set('Maxdistance', textFieldDistance);
                Storage.session.set('ActiveField', 'TextField');
                Storage.session.set('defaultDistance', defaultMaxDistance);
                Storage.session.set('DistanceUnit', distanceUnit);
              } else {
                Storage.session.set('Maxdistance', sliderDistance);
                Storage.session.set('ActiveField', 'Slider');
                Storage.session.set('defaultDistance', defaultMaxDistance);
                Storage.session.set('DistanceUnit', distanceUnit);
              }

              navigate('/availability');
            }}
            variant="contained"
            sx={{
              textTransform: 'none',
              width: '89px',
              height: '40px',
              borderRadius: '15px',
              border: '1px solid #FFCE00',
              boxShadow: 'none',
              '&:hover': { backgroundColor: 'primary.main', boxShadow: 'none' },
            }}
          >
            <Typography>Next</Typography>
          </Button>
        </Grid>
      </Stack>
    </Grid>
  );
};

export default EventsNearYou;
